import React from 'react';
import { X } from 'lucide-react';

const UiModalShell = ({
  title,
  subtitle = '',
  onClose,
  children,
  className = '',
  contentClassName = '',
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className={`w-full rounded-2xl bg-white shadow-xl ${className}`}>
        <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
          <div className="min-w-0">
            <h3 className="text-lg font-bold text-gray-800">{title}</h3>
            {subtitle ? <p className="mt-1 text-sm text-gray-500">{subtitle}</p> : null}
          </div>
          <button onClick={onClose} className="rounded-lg p-1 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700">
            <X size={22} />
          </button>
        </div>
        <div className={contentClassName || 'p-5'}>{children}</div>
      </div>
    </div>
  );
};

export default UiModalShell;
